export default function Header({ children, className = "", style = {} }) {
    return (
      <header className={`header ${className}`} style={style}>
        {children}
      </header>
    );
  }
  